import { isEmpty } from 'lodash';

export const isEmptyValue = value =>
  !value || isEmpty(value) || value?.trim()?.length === 0;

export const isNumeric = value => !isNaN(value);
